<form novalidate #currentForm="ngForm">
  <div class="form-group">
    <label>Number</label>
    <input 
      required 
      type="text" 
      #number="ngModel" 
      name="number" 
      [(ngModel)]="phoneNumber.number" 
      class="form-control form-control-sm" 
      (keyup)="changed(number)" />
    <div class="invalid-feedback d-block" *ngIf="!phoneNumber.number && formSubmitted">
      <div *ngIf="number.errors && number.errors.required">Number is required</div>
    </div>
  </div>
  <div class="form-group">
    <label>Extension</label>
    <input type="text" class="form-control form-control-sm" name="extension" [(ngModel)]="phoneNumber.extension" />
  </div>
  <div class="form-group">
    <label>Type</label>
    <select required class="form-control form-control-sm" name="phone_type_id" [(ngModel)]="phoneNumber.phone_type_id">
      <option *ngFor="let phoneType of formOptions.phone_types" [value]="phoneType.value">
        {{ phoneType.label }}
      </option>
    </select>
    <div class="invalid-feedback d-block" *ngIf="!phoneNumber.phone_type_id && formSubmitted">Type is required</div>
  </div>
  <div class="form-group">
    <label>Notes</label>
    <textarea class="form-control form-control-sm" name="notes" [(ngModel)]="phoneNumber.notes"></textarea>
  </div>
  <div class="form-row">
    <div class="col">
      <button type="button" (click)="save(currentForm)" class="btn btn-primary btn-block" [disabled]="formSubmitting">
        Save
        <span *ngIf="formSubmitting">
          &nbsp;
          <i class="fas fa-pulse fa-spinner fa-fw"></i>
        </span>
      </button>
    </div>
    <div class="col">
      <button type="button" class="btn btn-outline-secondary btn-block" [disabled]="formSubmitting" (click)="saved.emit(false)">Cancel</button>
    </div>
  </div>
</form>
